document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.tab-slide');
  if (!section) return;

  const tabs = section.querySelectorAll('.nav-item');
  const indicator = section.querySelector('.nav-indicator');
  const viewport = section.querySelector('.cards-viewport');
  const track = section.querySelector('.cards');
  const cards = section.querySelectorAll('.card');

  if (!tabs.length || !indicator) return;

  let activeIndex = 0;

  function moveIndicator(tab) {
    if(!tab) return;
    const pillRect = tab.parentElement.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();

    indicator.style.width = tabRect.width + 'px';
    indicator.style.transform = `translateX(${tabRect.left - pillRect.left}px)`;
  }

  function centerCard(index) {
    if (!tabs[index] || !cards[index]) return;
    
    activeIndex = index;
    
    const viewportRect = viewport.getBoundingClientRect();
    const card = cards[index];
    const viewportCenter = viewportRect.width / 2;
    const cardCenter = card.offsetLeft + card.offsetWidth / 2;

    const offset = viewportCenter - cardCenter;
    
    track.style.transform = `translateX(${offset}px)`;

    cards.forEach((c, i) => {
      c.classList.toggle('active', i === index);
    });
  }

  requestAnimationFrame(() => {
    moveIndicator(tabs[0]);
    centerCard(0);
  });

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      moveIndicator(tab);
      centerCard(index);
    });
  });

  window.addEventListener('resize', () => {
    moveIndicator(tabs[activeIndex]);
    centerCard(activeIndex);
  });
});